import Alpine from 'alpinejs';

Alpine.data('messages', (adminURL, id, userEmail) => ({
  adminURL,
  messages: [],
  loading: true,
  id,
  message: '',
  errors: [],
  init() {
    this.getMessages();
    this.fillForm();
  },
  fillForm() {
    const form = document.querySelector('.wpcf7');
    const inputUser = document.querySelector('input[name="user_email"]');

    inputUser.value = userEmail;
  },
  getMessages() {
    this.loading = true;
    const formData = new FormData();

    formData.append('action', 'getMessages');
    formData.append('id', this.id);

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        this.messages = res;
        this.loading = false;
      });
  },
  sendMessage() {
    this.errors = [];

    const formData = new FormData();
    formData.append('action', 'sendMessage');
    formData.append('message', this.message);
    formData.append('id', this.id);

    if (!this.message) return this.errors.push('Wiadomość jest wymagana');

    this.loading = true;

    const submitFormBtn = document.querySelector('.wpcf7-submit');
    submitFormBtn.click();

    fetch(this.adminURL, {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then(() => {
        this.message = '';
        this.getMessages();
      });
  },
}));
